import { cn } from '@/lib/utils'

type LabelPrintingDisabledNoticeProps = {
  className?: string
}

export function LabelPrintingDisabledNotice({ className }: LabelPrintingDisabledNoticeProps) {
  return (
    <div
      className={cn(
        'rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900',
        className
      )}
    >
      <p className="font-medium">Label printing disabled</p>
      <p className="mt-1">Create Exhibit ID labels manually for this show.</p>
    </div>
  )
}
